import { Box, Typography } from '@fe-toolkit/web-components/ssr'

import { TabItemActive, TabItemInactive, TabLi, TabOl } from './PseudoTabNavigation.styled'

export function PseudoTabNavigation({ onClick }: { onClick?: () => void }) {
  return (
    <Box as="nav" sx={{ position: 'relative' }}>
      <TabOl>
        <TabLi>
          <TabItemInactive href="/dashboard" onClick={onClick}>
            Mobile
          </TabItemInactive>
        </TabLi>
        <TabLi>
          <TabItemActive>
            <Typography variant="speakUp">Broadband</Typography>
          </TabItemActive>
        </TabLi>
      </TabOl>
    </Box>
  )
}
